import Image from "next/image";
import { VenuePagesRow } from "@punchup/data/legacy";
import { getCDNImageURL } from "@punchup/utils/getCDNImageURL";

export default function VenueSigninHeader({ venue }: { venue: VenuePagesRow }) {
  const { name, logo_img } = venue;
  const logoImgUrl = logo_img ? getCDNImageURL(logo_img) : null;
  return (
    <div className="flex flex-col items-center gap-4 md:pb-4">
      <div className="flex flex-row items-center justify-center w-full gap-6 px-4 pt-4 md:px-6">
        {logoImgUrl && (
          <Image
            className="rounded-full aspect-square"
            width={250}
            height={250}
            src={logoImgUrl}
            alt={`${name} logo`}
          />
        )}
      </div>
      <div className="flex flex-col items-center justify-center gap-1.5">
        <>
          <h1 className="font-sans text-[17px] font-bold leading-tight text-center normal-case md:text-xl">
            Join {name}&apos;s{" "}
            <span className="whitespace-nowrap">guest list</span>
          </h1>
          <p className="text-secondary-blue text-[13px] md:text-[16px] text-center leading-tight">
            Join for exclusive updates, first dibs on tickets, and more – no
            spam, just the good stuff!
          </p>
        </>
      </div>
    </div>
  );
}
